export default {"src":"/_next/static/media/stop-secondary.ef91ecb2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};